/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../../../../magnolia/lib/MagnoliaPropertyHelper';

export interface mobileAspectRatioStruct {
  aspectRatio ? : string;
}
export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface imageLinkStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
}
export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface ctaLinkStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
  title ? : string;
  ctaText ? : string;
  ctaTextColor ? : number;
  buttonColor ? : number;
  borderColor ? : number;
  pdfLinkInDam ? : Asset;
  showCtaAsPdf ? : boolean;
}
export default interface OneCTTextImageHalf {
  image: Asset;
  alt ? : string;
  imageTitle ? : string;
  aspectRatio ? : string;
  mobileAspectRatio ? : Array < mobileAspectRatioStruct > ;
  imageLink ? : Array < imageLinkStruct > ;
  topTitle ? : string;
  topTitleColor ? : number;
  title ? : string;
  titleColor ? : number;
  subText ? : string;
  subTextColor ? : number;
  ctaLink ? : Array < ctaLinkStruct > ;
  imageLoadType ? : string;
  dataABId ? : string;
  metadata ? : any;
}

export const Props = {
  image: Object as() => Asset,
  alt: String,
  imageTitle: String,
  aspectRatio: String,
  mobileAspectRatio: Array as() => Array < mobileAspectRatioStruct > ,
  imageLink: Array as() => Array < imageLinkStruct > ,
  topTitle: String,
  topTitleColor: Number,
  title: String,
  titleColor: Number,
  subText: String,
  subTextColor: Number,
  ctaLink: Array as() => Array < ctaLinkStruct > ,
  imageLoadType: String,
  dataABId: String,
  metadata: Object,
}

export const WrapperProps = {
  image: Object as() => Asset,
  alt: String,
  imageTitle: String,
  aspectRatio: String,
  mobileAspectRatio: Object,
  imageLink: Object,
  topTitle: String,
  topTitleColor: Number,
  title: String,
  titleColor: Number,
  subText: String,
  subTextColor: Number,
  ctaLink: Object,
  imageLoadType: String,
  dataABId: String,
  metadata: Object,
}

export class OneCTTextImageHalfBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class OneCTTextImageHalfInstance implements OneCTTextImageHalf {
      image: Asset;
      alt ? : string;
      imageTitle ? : string;
      aspectRatio ? : string;
      mobileAspectRatio ? : Array < mobileAspectRatioStruct > ;
      imageLink ? : Array < imageLinkStruct > ;
      topTitle ? : string;
      topTitleColor ? : number;
      title ? : string;
      titleColor ? : number;
      subText ? : string;
      subTextColor ? : number;
      ctaLink ? : Array < ctaLinkStruct > ;
      imageLoadType ? : string;
      dataABId ? : string;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (typeof this.image === 'object') {
          this.image = {
            ...this.image,
            link: this.image['@link'],
            name: this.image['@name'],
            path: this.image['@path'],
          };
        } else {
          this.image = null as any;
        }
        if (this.mobileAspectRatio) {
          this.mobileAspectRatio = Object.entries(this.mobileAspectRatio)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'mobileAspectRatio' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
        } else {
          this.mobileAspectRatio = null as any;
        }
        if (this.imageLink) {
          this.imageLink = Object.entries(this.imageLink)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'imageLink' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
          for (let i1 = 0; i1 < this.imageLink.length; i1++) {

            if (this.imageLink[i1]) {
              if (this.imageLink[i1].switchable) {
                if (typeof this.imageLink[i1].switchable.download === 'object') {
                  this.imageLink[i1].switchable.download = {
                    ...this.imageLink[i1].switchable.download,
                    link: this.imageLink[i1].switchable.download['@link'],
                    name: this.imageLink[i1].switchable.download['@name'],
                    path: this.imageLink[i1].switchable.download['@path'],
                  };
                } else {
                  this.imageLink[i1].switchable.download = null as any;
                }
              }
            }
          }
        } else {
          this.imageLink = null as any;
        }
        if (this.ctaLink) {
          this.ctaLink = Object.entries(this.ctaLink)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'ctaLink' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
          for (let i1 = 0; i1 < this.ctaLink.length; i1++) {

            if (this.ctaLink[i1]) {
              if (this.ctaLink[i1].switchable) {
                if (typeof this.ctaLink[i1].switchable.download === 'object') {
                  this.ctaLink[i1].switchable.download = {
                    ...this.ctaLink[i1].switchable.download,
                    link: this.ctaLink[i1].switchable.download['@link'],
                    name: this.ctaLink[i1].switchable.download['@name'],
                    path: this.ctaLink[i1].switchable.download['@path'],
                  };
                } else {
                  this.ctaLink[i1].switchable.download = null as any;
                }
              }
            }
            if (this.ctaLink[i1]) {
              if (typeof this.ctaLink[i1].pdfLinkInDam === 'object') {
                this.ctaLink[i1].pdfLinkInDam = {
                  ...this.ctaLink[i1].pdfLinkInDam,
                  link: this.ctaLink[i1].pdfLinkInDam['@link'],
                  name: this.ctaLink[i1].pdfLinkInDam['@name'],
                  path: this.ctaLink[i1].pdfLinkInDam['@path'],
                };
              } else {
                this.ctaLink[i1].pdfLinkInDam = null as any;
              }
            }
          }
        } else {
          this.ctaLink = null as any;
        }
      }
    }
    return new OneCTTextImageHalfInstance(props);
  }
}
